// One explicit schema for every provider. Never pass arbitrary form values or
// raw search/quiz answers through a caller's open-ended parameter object.
const STRING_KEYS = new Set([
  'cta_surface', 'page_path', 'page_type', 'post_slug', 'post_topic', 'cta_position',
  'destination', 'destination_type', 'destination_topic', 'experiment_variant',
  'app_store_campaign_token', 'capture_type', 'cta_component', 'cta_copy',
  'event_id', 'failure_stage', 'form_variant', 'offer_id', 'organic_query_family',
  'outbound_platform', 'product_slug', 'reason', 'trigger', 'validation_field',
  'validation_reason', 'method_version',
  'guess', 'brand_slug', 'campaign', 'card', 'comparison_slug', 'competitor',
  'format_slug', 'habit_slug', 'material_slug', 'product_category', 'scan_target', 'slide',
])
const NUMBER_KEYS = new Set([
  'category_count', 'error_status', 'guess_index', 'ingredient_token_count',
  'input_character_count', 'result_count', 'scan_count', 'high_count',
])
const BOOLEAN_KEYS = new Set(['external_completion_required', 'has_context', 'was_correct'])

export function sanitizeAnalyticsProperties(
  input: Record<string, unknown>,
): Record<string, string | number | boolean> {
  const clean: Record<string, string | number | boolean> = {}
  for (const [key, value] of Object.entries(input)) {
    if (NUMBER_KEYS.has(key) && typeof value === 'number' && Number.isFinite(value)) {
      clean[key] = value
    } else if (BOOLEAN_KEYS.has(key) && typeof value === 'boolean') {
      clean[key] = value
    } else if (STRING_KEYS.has(key) && typeof value === 'string') {
      let safe = value.trim()
      if (['destination', 'page_path'].includes(key)) {
        if (/^https?:\/\//.test(safe)) {
          try { const url = new URL(safe); safe = url.origin + url.pathname } catch { continue }
        } else {
          safe = safe.split(/[?#]/, 1)[0]
        }
      }
      if (!safe) continue
      try { if (/@|[\r\n]/.test(decodeURIComponent(safe))) continue } catch { continue }
      clean[key] = safe.slice(0, 100)
    }
  }
  return clean
}
